import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
// import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
// import { adminMainUrl } from '../../../../Config';
const EditMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        charge: Yup.string().required('Charge is required'),
        effectiveForm: Yup.string().required('Effective Form is required'),

        // name: Yup.string().required('Code is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            charge: "",
            effectiveForm: "",

        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });
    const ApplicableOption = []
    return (
        <Offcanvas className="" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Containers</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Received On <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                />

                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Container No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                />

                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                ISO Code <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='mt-2 custom-selector ' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Container DO <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='mt-2 custom-selector ' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Tare Wt. <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="d-flex">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                />
                                <Select className='custom-selector ms-2' />
                                </div>
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Payload <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="d-flex">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                />
                                <Select className='custom-selector ms-2' />
                                </div>
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Source <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='custom-selector' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                PickUp From <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='custom-selector' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Carrier Seal No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Reference <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='custom-selector' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Loading port <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='custom-selector' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Discharge port <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='custom-selector' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Vessel/Voyage <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='custom-selector' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Sent To <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='custom-selector' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Transporter <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select className='custom-selector' />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Vehicle No. <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Receipt No. <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Receipt Date <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                />
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="mb-1">
                                <label htmlFor="name" className="form-label">
                                Carrier Ref.No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Submit
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditMaster